import React from "react"

const SourceTitleHeader = ({ headerText = "" }) => {
  return headerText ? (
    <>
      <span className="aa-SourceHeaderTitle">{headerText}</span>
      <div className="aa-SourceHeaderLine" />
    </>
  ) : null
}

export default SourceTitleHeader
